import { useEffect, useRef, useState } from 'react';

/**
 * NAGŁÓWEK STRONY ODJEŻDŻA PRZY PRZEWIJANIU W DÓŁ, WRACA PRZY PRZEWIJANIU W GÓRĘ — wzór
 * Airbnb/Booking, tylko na wynikach wyszukiwania w układzie pulpitowym (zlecenie 28.09 po
 * zgłoszeniu Piotra z iPada). Blok wyszukiwania zostaje wtedy przyklejony do samej góry okna
 * jako całość, a żółty pasek powitalny i menu nie zjadają wysokości listy i mapy.
 *
 * Reguła jest czysta (`nastepnySchowany`), żeby dało się ją przetestować bez przeglądarki.
 */
export const PROG_DRGANIA = 4;

export function nastepnySchowany(
  schowany: boolean,
  y: number,
  poprzednieY: number,
  wysokoscNaglowka: number,
): boolean {
  // Przy samej górze strony nagłówek jest zawsze — schowanie go tam odsłoniłoby pustkę.
  if (y <= wysokoscNaglowka) return false;
  const krok = y - poprzednieY;
  // Mikroruchy (inercja, gumka na końcu listy w Safari) nie przełączają stanu — bez tego
  // nagłówek mrugałby przy każdym zatrzymaniu palca.
  if (krok > PROG_DRGANIA) return true;
  if (krok < -PROG_DRGANIA) return false;
  return schowany;
}

export function useChowanieNaglowka(
  aktywny: boolean,
  naglowek: { current: HTMLElement | null },
): boolean {
  const [schowany, setSchowany] = useState(false);
  const stan = useRef({ schowany: false, y: 0 });

  useEffect(() => {
    if (!aktywny) {
      stan.current.schowany = false;
      setSchowany(false);
      return;
    }
    stan.current.y = window.scrollY;
    let klatka = 0;
    const naPrzewiniecie = () => {
      if (klatka) return;
      klatka = window.requestAnimationFrame(() => {
        klatka = 0;
        const y = window.scrollY;
        const nastepny = nastepnySchowany(
          stan.current.schowany,
          y,
          stan.current.y,
          naglowek.current?.offsetHeight ?? 0,
        );
        stan.current.y = y;
        if (nastepny !== stan.current.schowany) {
          stan.current.schowany = nastepny;
          setSchowany(nastepny);
        }
      });
    };
    window.addEventListener('scroll', naPrzewiniecie, { passive: true });
    return () => {
      window.removeEventListener('scroll', naPrzewiniecie);
      if (klatka) window.cancelAnimationFrame(klatka);
    };
  }, [aktywny, naglowek]);

  return aktywny && schowany;
}
